import { Box, Stack, useTheme } from "@mui/material";
import { Card, IconButton, Text, VSpacer } from "@/components/DesignSystem";
import Edit from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Add from "@mui/icons-material/Add";
import React from "react";

interface BrandAssetsCardProps {
  color?: string | null,
  onAddClicked: () => void,
  onEditClicked?: () => void,
  onRemoveClicked?: () => void,
  statusText?: string | null,
  title: string,
}

export const BrandAssetsCard = ({
  color,
  statusText,
  onAddClicked,
  onEditClicked,
  onRemoveClicked,
  title,
}: BrandAssetsCardProps) => {
  const theme = useTheme();

  return (
    <Card
      cardContentStyle={{
        height: '100%',
        padding: '16px',
        width: '100%',
      }}
      elevation={0}
      sx={{ height: '100%' }}
      testID={`${title}-card`}
    >
      <Stack>
        <Stack alignItems="center" direction="row" justifyContent="space-between">
          <Stack sx={{ minWidth: 0 }}>
            <Text category="title-small">
              {title}
            </Text>
            {!!statusText && (
              <>
                <VSpacer size="2" />
                <Stack alignItems="center" direction="row" gap="4px">
                  {!!color && (
                    <Stack alignItems="center" height="24px" justifyContent="center" width="24px">
                      <Box bgcolor={color} borderRadius="2px" height="14px" width="14px" />
                    </Stack>
                  )}
                  <Text
                    category="body-medium"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                  >
                    {statusText}
                  </Text>
                </Stack>
              </>
            )}
          </Stack>
          {!!statusText && (
            <Stack direction="row" spacing={1.5}>
              {!!onEditClicked && (
                <IconButton
                  onClick={onEditClicked}
                  size="small"
                  square
                  sx={{
                    backgroundColor: theme.palette.surface2,
                    color: theme.palette.text.primary,
                  }}
                  testID={`${title}-edit-button`}
                  variant="outlined"
                >
                  <Edit />
                </IconButton>
              )}
              {!!onRemoveClicked && (
                <IconButton
                  onClick={onRemoveClicked}
                  size="small"
                  square
                  sx={{
                    backgroundColor: theme.palette.surface2,
                    color: theme.palette.text.primary,
                  }}
                  testID={`${title}-remove-button`}
                  variant="outlined"
                >
                  <DeleteOutline />
                </IconButton>
              )}
            </Stack>
          )}
        </Stack>
        {!statusText && (
          <>
            <VSpacer size="2" />
            <Stack direction="row" justifyContent="flex-end">
              <IconButton
                color="primary"
                onClick={onAddClicked}
                size="small"
                testID={`${title}-add-button`}
                variant="filled"
              >
                <Add />
              </IconButton>
            </Stack>
          </>
        )}
      </Stack>
    </Card>
  );
};
